<template>
  <div class="card">
    <div class="card-header">Inventario</div>

    <b-field class="file" v-if="permiso==1">
      <b-upload v-model="file">
        <a class="button is-info">
          <i class="fa fa-file-excel-o" aria-hidden="true"></i>
        </a>
      </b-upload>

      <span class="file-name" v-if="file">{{ file.name }}</span>
    </b-field>

    <div class="card-body">
      <div class="form-group row" v-if="permiso==1">
        <label class="col-sm-2 col-form-label">Código:</label>
        <div class="col-sm-5">
          <input
            type="codigo"
            v-model="producto.codigo"
            class="form-control"
            placeholder="Código del Producto"
          >
        </div>
      </div>
      <div class="form-group row" v-if="permiso==1">
        <label class="col-sm-2 col-form-label">Descripción:</label>
        <div class="col-sm-10">
          <input
            type="nombre"
            v-model="producto.descripcion"
            class="form-control"
            placeholder="Descripción del Producto"
          >
        </div>
      </div>
      <div class="form-group row" v-if="permiso==1">
        <label class="col-sm-2 col-form-label">Existencia:</label>
        <div class="col-sm-2">
          <input
            type="text"
            class="form-control"
            v-model="producto.existencia"
            placeholder="Existencia"
          >
        </div>
        <label class="col-sm-1 col-form-label">Marca:</label>
        <div class="col-sm-3">
          <input type="text" class="form-control" v-model="producto.marca" placeholder="Marca">
        </div>
         <label class="col-sm-2 col-form-label">Precio $:</label>
        <div class="col-sm-2">
          <input type="text" class="form-control" v-model="producto.precio" placeholder="$">
        </div>
      </div>

      <div class="row" v-if="permiso==1">
        <div class="col-md-4">
          <button class="btn btn-primary" @click="saveProducto">
            <i class="fa fa-save"></i>
            Guardar
          </button>
        </div>
      </div>
      <br>

      <!--  <div class="form-group row">
        <label class="col-sm-2 col-form-label">Buscar alumno:</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" placeholder="Nombre">
        </div>
      </div>
      </div>-->
      <div class="form group row">
        <label class="col-sm-4 col-form-label">Búsqueda por Descripción:</label>
        <div class="col-sm-6">
          <input type="text"  @keypress="clear_busqueda_codigo" class="form-control" v-model="busqueda_nombre">
        </div>
      </div>
      <br>
       <div class="form group row">
        <label class="col-sm-4 col-form-label">Búsqueda por Marca:</label>
        <div class="col-sm-6">
          <input type="text"  @keypress="clear_busqueda_marca" class="form-control" v-model="busqueda_marca">
        </div>
      </div>
      <br>
      <div class="form group row">
        <label class="col-sm-4 col-form-label">Búsqueda por Código:</label>
        <div class="col-sm-6">
          <input
            type="text"
            class="form-control"
            @keypress="clear_busqueda_nombre"
            v-model="busqueda_codigo"
          >
        </div>
      </div>
      <br>

      <div class="table-responsive">
        <table class="table table-striped">
          <tr>
            <th @click="sort('codigo')"><a style="color:black">Código</a></th>
            <th @click="sort('descripcion')"><a style="color:black">Descripción</a></th>
            <th v-if="permiso==1" @click="sort('existencia')"><a style="color:black">Existencia</a></th>
            <th @click="sort('marca')"><a style="color:black">Marca</a></th>
             <th @click="sort('precio')"><a style="color:black">Precio</a></th>
          </tr>
          <tbody v-if="lista_productos.length>0">
            <tr v-for="(obj,index) in sortedProductos" :key="index">
              <td>{{obj.codigo}}</td>
              <td>{{obj.descripcion}}</td>
              <td v-if="permiso==1">{{obj.existencia}}</td>
               <td>{{obj.marca}}</td>
               <td>{{obj.precio|toMXN}}</td>
                <td><btn class="btn btn-info" @click="openProductInfo(obj)" style="cursor:pointer"><i class="fa fa-file-pdf-o"></i></btn></td>


              <td>
                <a v-if="permiso==1"
                  style="margin-right: 10px; color:blue;cursor:pointer"
                  @click="editProducto(obj.idproducto)"
                  class="fa fa-edit"
                ></a>
                 <a v-if="permiso==1"
                style="color: red;cursor:pointer"
                class="fa fa-trash"
                @click="eliminarProducto(obj)"
                ></a>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
      <button v-if="busqueda_codigo=='' && busqueda_nombre=='' && busqueda_marca==''" @click="prevPage">Anterior</button>
      <button v-if="busqueda_codigo=='' && busqueda_nombre=='' && busqueda_marca==''" @click="nextPage">Siguiente</button>
    </div>
  </div>
</template>
<script>
import { url } from "../main.js";
export default {
  data() {
    return {
      file: null,
      permiso: 0,
       currentSort:'',
  currentSortDir:'',
  pageSize:10,
  currentPage:1,
      busqueda_nombre: "",
      busqueda_codigo: "",
      busqueda_marca:"",
      producto: {
        idproducto: 0,
        descripcion: "",
        existencia: "",
        marca: "",
        precio:""
      },

      lista_productos: []
    };
  },
  mounted() {
    this.permiso = localStorage.getItem("permission");
    this.verProductos();
  },
  computed:{
 sortedProductos(){

    if(this.busqueda_codigo!="")
  {
  return this.lista_productos.filter((producto)=>{
    console.log(producto);
      return producto.codigo.toUpperCase().match(this.busqueda_codigo.toUpperCase())
    });
  }else{
    if(this.busqueda_nombre!="")
    {
      return this.lista_productos.filter((producto)=>{
    console.log(producto);
      return producto.descripcion.toUpperCase().match(this.busqueda_nombre.toUpperCase())
    });

    }else{
      if(this.busqueda_marca!="")
     {
      return this.lista_productos.filter((producto)=>{
    console.log(producto);
      return producto.marca.toUpperCase().match(this.busqueda_marca.toUpperCase())
       });

     }else{
      

      return this.lista_productos.sort((a,b) => {
		let modifier = 1;
		if(this.currentSortDir === 'desc') modifier = -1;
		if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
		if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
		return 0;
	}).filter((row, index) => {
		let start = (this.currentPage-1)*this.pageSize;
		let end = this.currentPage*this.pageSize;
		if(index >= start && index < end) return true;
  })
     }
    }
  }
        
 }
  },
  methods: {
    uploadFile(file) {
      var formData = new FormData();
      formData.append("productos", file);

      this.axios
        .post(
          url + "apiProductos.php/up_products",
          formData,

          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(respuesta=> {
          console.log("SUCCESS!!");
          this.file= null;
           this.verProductos();
         
        })
        .catch(respuesta=> {
          console.log("FAILURE!!");
        
        });
    },
    saveProducto() {
      if (this.file != null) {
        console.log(this.file);
        this.uploadFile(this.file);
        
      }else{

      if(this.validarcampos())
      {
      if (this.producto != null) {
        console.log(this.producto);
        this.axios
          .post(url + "apiProductos.php/save_product", this.producto)
          .then(respuesta=> {
            console.log(respuesta);
             if (respuesta.data.status === 200) {
            
            this.$swal(respuesta.data.msg);
            this.verProductos();
          this.limpiarcampos();

          }
          })
          .catch(function() {
            console.log("FAILURE!!");
          });
      }
      }else{
         this.$swal("Por favor Ingrese todos los campos");
      }
      }
    },
    verProductos() {
      this.axios.get(url+"apiProductos.php/get_productos").then(respuesta => {
       console.log(respuesta)
      this.lista_productos=respuesta.data;

console.log(this.lista_productos);
      }).catch(function() {
            console.log("FAILURE ver!!");
          });
    },editProducto(idproducto)
    {
      this.axios
        .get(url + "apiProductos.php/get_producto/"+idproducto)
        .then(respuesta => {
          console.log(respuesta);
          this.producto = respuesta.data;
          
         
     
        });

    },
    eliminarProducto(producto){

      this.$swal({
        title: "Confirmación",
        text: "¿Desea eliminar el producto?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí, eliminar"
      }).then(result => {
        if (result.value) {
          this.$http
            .post(url + "apiProductos.php/delete_product",producto)
            .then(respuesta => {
              console.log(respuesta);

              if (respuesta.data.status === 200) {
                this.$swal("Producto Eliminado");
                this.verProductos();
              }
            });
        }
      });
    },

    clear_busqueda_codigo() {
      this.busqueda_codigo="";
      this.busqueda_marca=""
    },
    clear_busqueda_nombre(){
this.busqueda_nombre="";
this.busqueda_marca="";

    },
    clear_busqueda_marca(){
this.busqueda_nombre="";
this.busqueda_codigo="";
    },
   sort(s) {
       console.log('sort')
    //if s == current sort, reverse
    if(s === this.currentSort) {
      this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
    }
    this.currentSort = s;
  },nextPage:function() {
  if((this.currentPage*this.pageSize) < this.lista_productos.length) this.currentPage++;
},
prevPage:function() {
  if(this.currentPage > 1) this.currentPage--;
},
limpiarcampos()
{
 this.producto={};
},
validarcampos(){
  if(this.producto.descripcion=="" || this.producto.marca=="" || 
  this.producto.existencia=="" || this.producto.codigo=="")
  {
   return false;
  }else{
    return true;
  }
},
 openProductInfo(producto)
    {
 

       window.open("https://rubby2.hotel-arrecife.com/wsimportaciones/reporte_producto.php?producto="+producto.idproducto, "_blank"); 

    }
   
    
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/inventario.vue